import {
  createApiRef,
  DiscoveryApi,
  FetchApi,
} from '@backstage/core-plugin-api';
import { AiReadinessReport } from '@internal/backstage-plugin-ai-readiness-common';

export const aiReadinessApiRef = createApiRef<AiReadinessApi>({
  id: 'plugin.ai-readiness.api',
});

export interface AiReadinessApi {
  getReport(): Promise<AiReadinessReport>;
}

export class AiReadinessClient implements AiReadinessApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  /** `fetchApi` attaches the caller's Backstage token itself. */
  async getReport(): Promise<AiReadinessReport> {
    const baseUrl = await this.discoveryApi.getBaseUrl('ai-readiness');
    const response = await this.fetchApi.fetch(`${baseUrl}/report`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      const error = await response
        .json()
        .catch(() => ({ message: response.statusText }));
      throw new Error(
        error.message || `Request failed with status ${response.status}`,
      );
    }

    return response.json();
  }
}
